import { inject } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { SessionService } from '../../session.service';
import type { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import type { Observable } from 'rxjs';

export const restSessionInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const sessionService = inject(SessionService);
  return next(req).pipe(
    tap({
      next(event: HttpEvent<unknown>): void {
        if (event instanceof HttpResponse && sessionService.hasSessionTimedOut(event.headers, event.body as { envelope: { authorizationToken: string } } | undefined)) {
          sessionService.redirectToLoginPage(event.headers);
        }
      },
      error(error: unknown): void {
        if (error instanceof HttpErrorResponse
          && (error.status === 401 || sessionService.hasSessionTimedOut(error.headers))) {
          sessionService.redirectToLoginPage(error.headers);
        }
      }
    })
  );
};
